"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CharacterStatsWindow;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _CharacterStatsWindowModule = _interopRequireDefault(require("./CharacterStatsWindow.module.scss"));

var _Resistances = _interopRequireDefault(require("./components/Resistances/Resistances"));

var _AttackAndDef = _interopRequireDefault(require("./components/AttackAndDef/AttackAndDef"));

var _PrimarySummary = _interopRequireDefault(require("./components/PrimarySummary/PrimarySummary"));

var _Energy = _interopRequireDefault(require("./components/Energy/Energy"));

var _MainAttributes = _interopRequireDefault(require("./components/MainAttributes/MainAttributes"));

var _WindowControls = _interopRequireDefault(require("../../WindowControls/WindowControls"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CharacterStatsWindow(_ref) {
  var character = _ref.character,
      characterClass = _ref.characterClass,
      nation = _ref.nation,
      guild = _ref.guild,
      _ref$isPhyAttImproved = _ref.isPhyAttImproved,
      isPhyAttImproved = _ref$isPhyAttImproved === void 0 ? false : _ref$isPhyAttImproved,
      _ref$isPhyDefImproved = _ref.isPhyDefImproved,
      isPhyDefImproved = _ref$isPhyDefImproved === void 0 ? false : _ref$isPhyDefImproved,
      _ref$isMagAttImproved = _ref.isMagAttImproved,
      isMagAttImproved = _ref$isMagAttImproved === void 0 ? false : _ref$isMagAttImproved,
      _ref$isMagDefImproved = _ref.isMagDefImproved,
      isMagDefImproved = _ref$isMagDefImproved === void 0 ? false : _ref$isMagDefImproved,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;
  var name = character.name,
      level = character.level,
      rank = character.rank,
      energy = character.energy,
      resistance = character.resistance,
      offense = character.offense,
      defense = character.defense,
      attributePoints = character.attributePoints,
      mainAttributes = character.mainAttributes,
      mainAttributeBonuses = character.mainAttributeBonuses,
      reputation = character.reputation,
      experience = character.experience,
      experienceMax = character.experienceMax;
  var nationI18nName = nation.i18nName;
  var guildName = "";
  if (guild) guildName = guild.name;
  var characterClassI18nName = characterClass.i18nName;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_CharacterStatsWindowModule.default.window, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement(_WindowControls.default, {
    classNameDragHandler: _CharacterStatsWindowModule.default.dragHandler,
    classNameCloseBtn: _CharacterStatsWindowModule.default.closeBtn
  }), /*#__PURE__*/_react.default.createElement(_PrimarySummary.default, {
    name: name,
    nationI18nName:
    /* TODO: i18n */
    nationI18nName.en,
    guildName: guildName,
    rank: rank,
    reputation: reputation,
    characterClassI18nName:
    /* TODO: i18n */
    characterClassI18nName.en,
    level: level,
    experience: experience,
    experienceMax: experienceMax
  }), /*#__PURE__*/_react.default.createElement(_Energy.default, {
    energy: energy
  }), /*#__PURE__*/_react.default.createElement(_MainAttributes.default, {
    attributePoints: attributePoints,
    mainAttributes: mainAttributes,
    mainAttributeBonuses: mainAttributeBonuses
  }), /*#__PURE__*/_react.default.createElement(_AttackAndDef.default, {
    offense: offense,
    defense: defense,
    isPhyAttImproved: isPhyAttImproved,
    isPhyDefImproved: isPhyDefImproved,
    isMagAttImproved: isMagAttImproved,
    isMagDefImproved: isMagDefImproved
  }), /*#__PURE__*/_react.default.createElement(_Resistances.default, {
    resistance: resistance
  }));
}